import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";
import getCreateProgressDownload from "../../DependencyInjection/createProgressDownload";
import Progress from "../../ValueObject/Progress";
import {PartialDownloadProgress} from "../../../../types/downloadManager";

const eventDispatcher = getEventDispatcher();

const PartialDownloadProgressListener: EventHandler<PartialDownloadProgress> = async (event: IpcMainInvokeEvent, content: PartialDownloadProgress): Promise<void> => {
    const progress: Progress = getCreateProgressDownload().fromPartial(content);
    await eventDispatcher.dispatch('ChangeProgressDownloadAction', progress);
}

export default PartialDownloadProgressListener;